import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";
import { Button } from "./ui/button";

export default function CatalogPagination({ total, pagina, paginas, limite, loading, onPageChange, anchor = false }) {
  if (!total) return null;
  const first = (pagina - 1) * limite + 1;
  const controls = [
    ["Primeira página", ChevronsLeft, 1, pagina === 1],
    ["Página anterior", ChevronLeft, pagina - 1, pagina === 1],
    ["Próxima página", ChevronRight, pagina + 1, pagina >= paginas],
    ["Última página", ChevronsRight, paginas, pagina >= paginas],
  ];
  const changePage = (target) => {
    onPageChange(target);
    document.querySelector("[data-catalog-start]")?.scrollIntoView({ block: "start" });
  };
  return <nav aria-label="Paginação do catálogo" data-catalog-start={anchor ? "" : undefined} className="flex scroll-mt-20 flex-wrap items-center justify-between gap-3 py-2">
    <p className="text-sm text-slate-500">{first}–{Math.min(pagina * limite, total)} de {total} · Página {pagina} de {paginas}</p>
    <div className="flex shrink-0 gap-1">{controls.map(([label, Icon, target, disabled]) => <Button key={label} type="button" variant="outline" size="icon" title={label} aria-label={label} disabled={loading || disabled} onClick={() => changePage(target)}><Icon className="h-4 w-4" /></Button>)}</div>
  </nav>;
}
